export default __webpack_public_path__ + "static/media/white01.716e51fb.jpg";